import React, { useState } from "react";

interface FieldErrorDictionary {
    [fieldName: string]: boolean;
}

export default function useFormContext(formRef: React.RefObject<HTMLFormElement>): IFormContext {

    const [errors, setErrors] = useState<FieldErrorDictionary>({});
    const [isValidated, setIsValidated] = useState(false);


    function validate(): boolean {
        setIsValidated(true);
        const isValid = Object.values(errors).filter(isValid => !isValid).length === 0;
        return isValid && formRef.current.checkValidity();
    }

    function setField(fieldName: string, isValid: boolean) {
        setErrors(m => {
            m[fieldName] = isValid;
            return m;
        });
    }

    return {
        isValidated: isValidated,
        validate: validate,
        setField: setField
    }
}

export interface IFormContext {
    setField(fieldName: string, isValid: boolean): unknown;
    isValidated: boolean;
    validate(): boolean;
}

export const FormContext = React.createContext<IFormContext>({
    isValidated: false,
    setField: () => { },
    validate: () => true
});